import {
  Lightning,
  GameController,
  Microphone,
  YoutubeLogo,
  Coffee,
  Broadcast,
  Record,
  Play,
  Globe,
  House,
  Briefcase,
  Code,
  Camera,
  ChatCircle,
  EnvelopeSimple,
  Calendar,
  ChartBar,
  ShoppingCart,
  Image as ImageIcon,
  MusicNote,
  Cloud,
  Cube,
  PencilSimple,
  Heart,
  Star,
  Stack,
  Folder,
  ArrowUpRight,
  Globe as GlobeIcon,
  GithubLogo,
  TwitterLogo,
  LinkedinLogo,
  InstagramLogo,
  TiktokLogo,
  DiscordLogo,
  SlackLogo,
  GoogleLogo,
  FigmaLogo,
  NotionLogo,
  SpotifyLogo,
  TwitchLogo,
  WhatsappLogo,
  TelegramLogo,
  Sparkle,
  Robot,
  ChatTeardropDots,
  Books,
  GraduationCap,
  Bank,
  Wallet,
  Headphones,
  FilmStrip,
  Path,
  Lightbulb,
  Wrench,
  Gear,
} from "@phosphor-icons/react";

export const ICON_MAP = {
  Lightning,
  GameController,
  Microphone,
  YoutubeLogo,
  Coffee,
  Broadcast,
  Record,
  Play,
  Globe,
  House,
  Briefcase,
  Code,
  Camera,
  ChatCircle,
  EnvelopeSimple,
  Calendar,
  ChartBar,
  ShoppingCart,
  ImageIcon,
  MusicNote,
  Cloud,
  Cube,
  PencilSimple,
  Heart,
  Star,
  Stack,
  Folder,
  ArrowUpRight,
  GithubLogo,
  TwitterLogo,
  LinkedinLogo,
  InstagramLogo,
  TiktokLogo,
  DiscordLogo,
  SlackLogo,
  GoogleLogo,
  FigmaLogo,
  NotionLogo,
  SpotifyLogo,
  TwitchLogo,
  WhatsappLogo,
  TelegramLogo,
  Sparkle,
  Robot,
  ChatTeardropDots,
  Books,
  GraduationCap,
  Bank,
  Wallet,
  Headphones,
  FilmStrip,
  Path,
  Lightbulb,
  Wrench,
  Gear,
};

export const ICON_NAMES = Object.keys(ICON_MAP);

export function resolveIcon(name) {
  return ICON_MAP[name] || GlobeIcon;
}

export default function IconPicker({ value, onChange }) {
  return (
    <div
      data-testid="icon-picker"
      className="grid grid-cols-7 gap-2 max-h-[260px] overflow-y-auto p-1"
    >
      {ICON_NAMES.map((name) => {
        const Icon = ICON_MAP[name];
        const active = value === name;
        return (
          <button
            key={name}
            type="button"
            data-testid={`icon-opt-${name}`}
            onClick={() => onChange(name)}
            title={name}
            className={`w-10 h-10 rounded-xl flex items-center justify-center border transition ${
              active
                ? "bg-[#2563EB]/20 border-[#2563EB] text-[#FACC15]"
                : "bg-white/5 border-white/10 text-white/60 hover:bg-white/10 hover:text-white"
            }`}
          >
            <Icon size={18} weight={active ? "fill" : "bold"} />
          </button>
        );
      })}
    </div>
  );
}
